import { client } from './client'

import type {
  CreateReportBody,
  CreateReportResponse,
  ListReportsParams,
  ListReportsResponse,
  Report,
  ReportFormat,
  ReportStatusResponse,
} from './types'

export const createReport = async (body: CreateReportBody): Promise<CreateReportResponse> => {
  const { data } = await client.post<CreateReportResponse>('/reports', body)

  return data
}

export const listReports = async (params: ListReportsParams): Promise<ListReportsResponse> => {
  const { data } = await client.get<ListReportsResponse>('/reports', { params })

  return data
}

export const getReportStatus = async (jobId: Report['jobId']): Promise<ReportStatusResponse> => {
  const { data } = await client.get<ReportStatusResponse>(`/reports/${jobId}/status`)

  return data
}

export const getReportFile = async (
  jobId: Report['jobId'],
  format: ReportFormat,
): Promise<Blob> => {
  const { data } = await client.get<Blob>(`/reports/${jobId}`, {
    params: { format },
    responseType: 'blob',
  })

  return data
}
